<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import { debounce } from "../../../helpers/helper";
import EasySlider from "vue-easy-slider";
import Vue from "vue";
import moment from "moment";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import VueIframe from "vue-iframes";

Vue.use(EasySlider);
Vue.use(VueIframe);
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Posts",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    const { perPage, status, orderBy, sortBy } = this.$route.query;
    return {
      iframeWidth: "100%",
      iframeHeight: "100%",
      iframeScrolling: "auto",
      moment,
      exporting: false,
      showSidebar: false,
      seen: true,
      active_el: 2,
      sortBy: sortBy || "created_at",
      sortDesc: orderBy && orderBy != "" ? orderBy : true,
      limit: 2,
      perPage: perPage || 2,
      search: "",
      image_url: process.env.VUE_APP_MIX_BASE_URL + "images/download.png",
      status: status == undefined ? "1" : status,
      company_image: process.env.VUE_APP_MIX_BASE_URL + "images/app_icon.png",
      user_image: process.env.VUE_APP_MIX_BASE_URL + "images/user.png",
      like_users: "",
      data: {
        data: "",
      },
      user: {
        email: "",
        message: "",
        post_id: "",
      },
      searchData: debounce(() => {
        const { perPage, status, orderBy, sortBy } = this.$data;
        this.$router.replace({
          name: "post.list",
          query: { perPage, status, orderBy, sortBy },
        });
        let page = 1;
        this.getPostList({
          page: page,
          perPage: this.perPage,
          search: this.search,
          status: this.status,
          sortBy: this.sortBy,
          orderBy: this.sortDesc ? "desc" : "asc",
        });
      }, 500),
      fields: [
        {
          key: "id",
          label: this.$t("userManagement.list.ID"),
          sortable: true,
        },
        {
          key: "post_description",
          label: this.$t("companyManagement.list.description"),
          sortable: true,
        },
        {
          key: "is_active",
          label: this.$t("userManagement.list.status"),
          sortable: false,
        },
        {
          key: "action",
          label: this.$t("companyManagement.list.action"),
          sortable: false,
        },
      ],
    };
  },
  validations: {
    user: {
      message: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(5000),
      },
    },
  },

  computed: mapGetters("post", [
    "loading",
    "postCount",
    "postData",
    "posts",
    "paginations",
    "counts"
  ]),
  mounted() {
    let orderBy = this.sortDesc ? "desc" : "asc";
    let page = 1;
    this.getPostList({
      page: page,
      perPage: this.perPage,
      search: this.search,
      status: this.status,
      sortBy: this.sortBy,
      orderBy: orderBy,
    });
    const loggeduser = JSON.parse(localStorage.getItem("user"));
    this.user.email = loggeduser.email;

  },
  methods: {
    ...mapActions("post", [
      "getPostList",
      "getExportCSVData",
      "deletePost",
      "postVotes",
      "showPost",
      "likePost",
      "postReport",
    ]),

    downloadsCSV: function () {
      this.exporting = true;
      this.getExportCSVData({
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
      }).then((res) => {
        this.exporting = false;
        if (res) {
          let postData = "\ufeff" + "Id,Title,Description,Status\n";
          this.postData.forEach((el) => {
            var line =
              el["id"] +
              "," +
              el["post_description"] +
              "," +
              (el["is_active"] == 1 ? "Active" : "InActive") +
              "\n";
            postData += line;
          });
          var blob = new Blob([postData], { type: "csv/plain" });
          var date = new Date().toLocaleString();
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Posts" + date + ".csv";
          link.click();
        }
      });
    },
    sortingChanged(ctx) {
      let page = 1;
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getPostList({
        page: page,
        perPage: this.perPage,
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: this.sortDesc,
      });
      // this.getExportCSVData({
      //   page: page,
      //   search: this.search,
      //   status: this.status,
      //   sortBy: this.sortBy,
      //   orderBy: this.sortDesc,
      // });
    },
    getPosts(page = 1) {
      let orderBy = this.sortDesc ? "desc" : "asc";

      this.getPostList({
        page: page,
        perPage: this.perPage,
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: orderBy,
      });
      //   this.getExportCSVData({
      //     page: page,
      //     search: this.search,
      //     status: this.status,
      //     sortBy: this.sortBy,
      //     orderBy: orderBy,
      //  });
    },
    deletePostName(id) {
      if (confirm("Do you really want to delete?")) {
        this.deletePost(id).then((res) => {
          if (res.success) {
            this.getPosts(this.paginations.meta.current_page);
          }
        });
      }
    },
    editPostName(id) {
      this.$router.push({ name: "post.edit", params: { id: id } });
    },
    postVote(postId,vote) {
      this.postVotes({postId,vote}).then((res) => {
          if (res.success) {
            this.getPosts(this.paginations.meta.current_page);
          }
        });
    },
    activate: function (el) {
      this.active_el = el;
    },

    getToggelData(id) {
      this.showPost(id).then((res) => {
        this.like_users = res.data.like_users.concat(res.data.like_companies);
        this.showSidebar = !this.showSidebar;
      });
      //  document.body.classList.toggle("right-bar-enabled");
    },
    hello($event) {
      console.log(`hello index: ${$event}`);
    },
    showPostData(id) {
      this.$router.push({ name: "post.show", params: { id: id } });
    },
    imageNotFound(event) {
      event.target.src = process.env.VUE_APP_MIX_BASE_URL + "images/download.png";
    },
    likes(post_id) {
      this.likePost(post_id).then((res) => {
        if (res.success) {
          this.getPosts(this.paginations.meta.current_page);
        }
      });
    },
    comments(post_id) {
      this.$router.push({
        name: "post.show",
        params: { id: post_id },
        query: { seen: 1 },
      });
    },
    reportPostName(post_id) {
      this.user.post_id = post_id;
      this.$refs["my-modal"].show();
    },
    reportSubmit() {
      this.$v.user.$touch();
      if (this.$v.user.$invalid) {
        return;
      } else {
        var data = this.user;

        this.postReport(data).then((res) => {
          if (res) {
            this.$refs["my-modal"].hide();
            const loggeduser = JSON.parse(localStorage.getItem("user"));

            this.user = {
              message: "",
              email: loggeduser.email,
            };
            this.$v.user.$reset();
            this.getPosts(this.paginations.meta.current_page);
          }
        });
      }
    },
    companyimageNotFound(event) {
      event.target.src = process.env.VUE_APP_MIX_BASE_URL + "images/app_icon.png";
    },
    userimageNotFound(event) {
      event.target.src = process.env.VUE_APP_MIX_BASE_URL + "images/user.png";
    },
    onLoad(frame) {
      this.myIframe = frame.contentWindow;
    },
    getRepostData(id) {
      this.showPost(id).then((res) => {
        if (res) {
          this.$router.push({
            name: "post.show",
            params: { id: id },
          });
        }
      });
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left">
            <div class="avatar-xs mr-3">
              <!-- <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                      <i class="bx-category-alt"></i>
              </span> -->
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">Posts({{ postCount }})</h4>
            </div>
          </div>
          <div class="page-title-right d-flex">
            <router-link
              :to="{ name: 'post.add' }"
              class="btn btn-success btn-rounded mr-2 add-btn"
            >
              <i class="mdi mdi-plus mr-1"></i>{{ $t("add_post") }}
            </router-link>
            <button
              @click="downloadsCSV"
              class="btn btn-primary btn-rounded export-btn"
              :disabled="exporting"
            >
              {{ exporting ? $t("Exporting...") : $t("export_csv") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row list-table-main">
      <div class="col-lg-8 col-xl-9">
        <div class="card">
          <div class="card-body">
            <div class="justify-content-center row">
              <div class="col-xl-9">
                <div>
                  <div class="align-items-center row">
                    <div class="col-4">
                      <div>
                        <h5 class="mb-0">All Post</h5>
                      </div>
                    </div>
                    <div class="col-8">
                      <div>
                        <ul class="nav nav-pills justify-content-end">
                          <li class="nav-item">
                            <a to="#" tabindex="-1" class="disabled nav-link">View :</a>
                          </li>
                          <li class="nav-item">
                            <a
                              class="nav-link"
                              href="#"
                              v-on:click="seen = false"
                              @click="activate(1)"
                              :class="{ active: active_el == 1 }"
                            >
                              <i class="mdi mdi-format-list-bulleted"></i>
                            </a>
                          </li>
                          <li class="nav-item">
                            <a
                              class="nav-link"
                              href="#"
                              v-on:click="seen = true"
                              @click="activate(2)"
                              :class="{ active: active_el == 2 }"
                            >
                              <i class="mdi mdi-view-grid-outline"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <hr class="mb-4" />
                  <div v-if="posts && posts.length > 0">
                    <div class="row" v-if="seen">
                      <div class="col-sm-6" v-for="post in posts" :key="post.id">
                        <div class="p-1 border shadow-none card">
                          <div class="p-3">
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                width: 100% !important;
                                justify-content: space-between;
                              "
                            >
                              <div style="display: flex; align-items: center">
                                <img
                                  :src="
                                    post.auth_details.image_path +
                                    '/' +
                                    post.auth_details.image
                                  "
                                  alt=""
                                  class="avatar-md h-auto d-block rounded-circle mr-3"
                                  v-if="post.auth_details.image"
                                  style="height: 35px !important; width: 35px !important"
                                  @error="companyimageNotFound"
                                />
                                <img
                                  :src="company_image"
                                  alt=""
                                  class="avatar-md h-auto d-block rounded-circle mr-3"
                                  style="height: 35px !important; width: 35px !important"
                                  v-else
                                />
                                <div style="display: grid">
                                  <router-link
                                    :to="{
                                      name: 'post.show',
                                      params: { id: post.id },
                                    }"
                                    class="text-dark"
                                    ><span>{{
                                      post.auth_details.name
                                    }}</span></router-link
                                  >

                                  <small v-if="post.created_at" class="text-muted">{{
                                    moment(post.created_at).fromNow()
                                  }}</small>
                                  <small v-else class="text-muted">-</small>
                                </div>
                              </div>

                              <b-dropdown
                                class="float-right ml-5"
                                toggle-class="text-muted p-0"
                                right
                                variant="white"
                              >
                                <template v-slot:button-content>
                                  <i class="mdi mdi-dots-horizontal font-size-18"></i>
                                </template>
                                <b-dropdown-item
                                  @click="editPostName(post.id)"
                                  v-if="!post.parent_post & !post.repost_id"
                                  >Edit</b-dropdown-item
                                >
                                <b-dropdown-item @click="deletePostName(post.id)"
                                  >Delete</b-dropdown-item
                                >
                                <!-- <b-dropdown-item @click="reportPostName(post.id)"
                                  >Report</b-dropdown-item
                                > -->
                              </b-dropdown>
                              <!-- <button class="btn" @click="editPostName(post.id)"><i class="bx bx-pencil" aria-hidden="true"></i></button>
                                  <button class="btn" @click="deletePostName(post.id)"><i class="bx bx-trash"></i></button> -->
                            </div>
                          </div>
                          <div v-if="!post.parent_post">
                            <div class="pt-3 pb-2 pl-3">
                              <div v-if="post && post.post_description !== null && post.post_description !== ''">
                                <div
                                  v-html="post.post_description"
                                  id="app"
                                  style="white-space: pre-wrap"
                                  class="text-dark"
                                  v-on:click="isHidden = false"
                                  @click="showPostDetail(post.id)"
                                  v-if="post && post.post_description.length < 500"
                                >
                                </div>
                                <div
                                  v-html="post.post_description.substring(0, 500) + '..'"
                                  id="app"
                                  style="white-space: pre-wrap"
                                  class="text-dark"
                                  v-on:click="isHidden = false"
                                  @click="showPostDetail(post.id)"
                                  v-else
                                ></div>
  
                                <div v-if="post.post_description.length > 500" class="mb-2">
                                  <router-link
                                    :to="{
                                      name: 'post.show',
                                      params: { id: post.id },
                                    }"
                                    class="text-primary"
                                    >Read more <i class="mdi mdi-arrow-right"></i
                                  ></router-link>
                                </div>
                              </div>
                            </div>

                            <div v-if="post.website_url || post.posts_images.length > 0 && post.type !== 'Poll'">
                              <div class="position-relative" v-if="post.website_url">
                                <div class="repost-border1">
                                  <a
                                    :href="post.website_url"
                                    class="text-primary"
                                    target="_blank"
                                  >
                                    <div class="" style="width: 100% !important">
                                      <div
                                        style="
                                          display: flex;
                                          align-items: center;
                                          width: 100% !important;
                                          justify-content: space-between;
                                        "
                                      >
                                        <div style="display: flex; align-items: center">
                                          <img
                                            :src="post.website_image"
                                            alt=""
                                            v-if="post.website_image"
                                            style="
                                              width: 100% !important;
                                              object-fit: cover;
                                            "
                                            @error="companyimageNotFound"
                                          />
                                        </div>
                                      </div>
                                      <div
                                        style="
                                          background-color: #e8e8e8;
                                          width: 100% !important;
                                          object-fit: cover;
                                          padding: 10px;
                                        "
                                      >
                                        <span
                                          style="color: #000"
                                          class="text-dark"
                                          v-if="post.website_title"
                                        >
                                          <h6>{{ post.website_title }}</h6>
                                        </span>
                                        <span
                                          style="color: #000"
                                          class="text-dark"
                                          v-if="post.website_description"
                                        >
                                          {{ post.website_description }}
                                        </span>
                                      </div>
                                    </div>
                                  </a>
                                </div>
                              </div>

                              <div class="position-relative" v-else>
                                <div v-if="post.images.length > 1">
                                  <slider animation="fade" style="width: 100% !important">
                                    <slider-item
                                      v-for="index in post.images"
                                      :key="index"
                                      @click="hello"
                                    >
                                      <img
                                        :src="index.image_path + '/' + index.image"
                                        style="
                                          height: 300px !important;
                                          width: 100% !important;
                                          object-fit: cover;
                                        "
                                        @error="imageNotFound"
                                      />
                                    </slider-item>
                                  </slider>
                                </div>
                                <div v-else-if="post.images.length == 1">
                                  <video
                                    style="
                                      height: auto !important;
                                      width: 100% !important;
                                      object-fit: cover;
                                    "
                                    v-if="post.images[0].type == 'Video'"
                                    controls
                                    :src="
                                      post.images[0].image_path +
                                      '/' +
                                      post.images[0].image
                                    "
                                  ></video>

                                  <img
                                    :src="
                                      post.images[0].image_path +
                                      '/' +
                                      post.images[0].image
                                    "
                                    alt=""
                                    class="img-thumbnail"
                                    style="
                                      height: auto !important;
                                      width: 100% !important;
                                      object-fit: cover;
                                    "
                                    v-if="post.images[0].type == 'Image'"
                                    @error="imageNotFound"
                                  />

                                  <!-- <span v-if="post.images[0].type == 'File'" class="pl-3">{{
                                    post.images[0].image
                                  }}</span> -->
                                  <!-- <vue-iframe
                                    v-if="post.images[0].type == 'File'"
                                    :src="
                                      post.images[0].image_path + '/' + post.images[0].image
                                    "
                                    allow="camera *; geolocation *; microphone *; autoplay *"
                                    frame-id="my-ifram"
                                    @load="onLoad"
                                    name="my-frame"
                                    :scrolling="iframeScrolling"
                                    :width="iframeWidth"
                                    :height="iframeHeight"
                                  /> -->

                                  <!-- <iframe
                                    :src="
                                      post.image[0].image_path + '/' + post.image[0].image
                                    "
                                    width="100%"
                                    height="100"
                                    frameborder="0"
                                    v-if="post.images[0].type == 'File'"
                                  >
                                  </iframe> -->

                                  <div
                                    class="embed-responsive embed-responsive-16by9"
                                    v-if="post.images[0].type == 'File'"
                                  >
                                    <iframe
                                      class="embed-responsive-item"
                                      :src="
                                        post.images[0].image_path +
                                        '/' +
                                        post.images[0].image
                                      "
                                    ></iframe>
                                  </div>
                                </div>
                                <div v-else>
                                  <img
                                    :src="image_url"
                                    alt=""
                                    class="img-thumbnail"
                                    style="
                                      height: auto !important;
                                      width: 100% !important;
                                      object-fit: cover;
                                    "
                                  />
                                </div>
                              </div>
                            </div>
                            <div v-else>
                              <div v-if="post.type == 'Poll'">
                                <div class="position-relative pt-3 pb-2 pl-3">
                                  <div class="border p-1 box-sha ">
                                    <h6 class="p-1"> {{ post.question }}</h6>
                                    <div>
                                      <template v-if="post.poll_result">
                                        <div v-if="!post.votes_count">
                                          <div v-for="(option, index) in post.options" :key="index" class="p-1 text-center options" :class="{ 'mt-1': index >= 1 }" >
                                            <div>{{ option }}</div>
                                          </div>
                                        </div>
                                        <div v-else>
                                          <div v-if="post.votes_count">
                                            <div  v-for="(vote,index) in post.votes" :key="index">
                                              <h6 class="mt-1 vote-count p-1">{{ index }}</h6>
                                              <template v-if="((vote/post.votes_count) * 100).toFixed(2) > 0">
                                                <b-progress :max="100" height="1rem" animated>
                                                  <b-progress-bar :value="((vote/post.votes_count) * 100).toFixed(2)" >
                                                    <strong>{{ ((vote/post.votes_count) * 100).toFixed(2) }}%</strong>
                                                  </b-progress-bar>
                                                </b-progress>
                                              </template>
                                              <template v-else>
                                                <div class="justify-content-around progress" style="line-height:2!important;height: 1rem!important;">
                                                  <p class="text-center"><strong>0%</strong></p>
                                                </div>
                                              </template>
                                            </div>
                                          </div>
                                        </div>
                                      </template>
                                      <template v-else>
                                        <div v-if="!post.is_voted">
                                          <div v-for="(option, index) in post.options" :key="index" class="p-1 text-center options" :class="{ 'mt-1': index >= 1 }" >
                                            <div @click="postVote(post.id,option)">{{ option }}</div>
                                          </div>
                                        </div>
                                        <div v-if="post.is_voted">
                                          <div  v-for="(vote,index) in post.votes" :key="index">
                                            <h6 class="mt-1 vote-count p-1">{{ index }}</h6>
                                            <template v-if="((vote/post.votes_count) * 100).toFixed(2) > 0">
                                              <b-progress :max="100" height="1rem" animated>
                                                <b-progress-bar :value="((vote/post.votes_count) * 100).toFixed(2)" >
                                                  <strong>{{ ((vote/post.votes_count) * 100).toFixed(2) }}%</strong>
                                                </b-progress-bar>
                                              </b-progress>
                                            </template>
                                            <template v-else>
                                              <div class="justify-content-around progress" style="line-height:2!important;height: 1rem!important;">
                                                <p class="text-center"><strong>0%</strong></p>
                                              </div>
                                            </template>
                                          </div>
                                        </div>
                                      </template>
                                      <h6 class="mt-2 vote-count p-1"> {{ post.votes_count }} Votes</h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="pl-2 pr-2" v-else>
                            <div v-if="post.repost_id && post.parent_post">
                              <div v-if="post && post.post_description !== null && post.post_description !== ''">
                                <div
                                  v-html="post.post_description"
                                  id="app"
                                  style="white-space: pre-wrap"
                                  class="text-dark pb-3"
                                  v-if="post.post_description.length < 500"  
                                ></div>
                                <div
                                  v-html="
                                    post.post_description.substring(
                                      0,
                                      500
                                    ) + '..'
                                  "
                                  id="app"
                                  style="white-space: pre-wrap"
                                  class="text-dark pb-3"
                                  v-else
                                ></div>
                                <div
                                  v-if="post.post_description.length > 500"
                                  class="mb-2"
                                >
                                  <router-link
                                    :to="{
                                      name: 'company.newsfeeds.show',
                                      params: { id: post.id },
                                    }"
                                    class="text-primary"
                                    >Read more <i class="mdi mdi-arrow-right"></i
                                  ></router-link>
                                </div>
                              </div>

                              <div class="repost-border pr-2 pl-2">
                                <a
                                class="text-dark"
                                href="javascript:void(0)"
                                @click="getRepostData(post.repost_id)"
                                >
                                  <div class="p-1">
                                    <div
                                    style="
                                        display: flex;
                                        align-items: center;
                                        width: 100% !important;
                                        justify-content: space-between;
                                        "
                                    >
                                      <div
                                        style="display: flex; align-items: center"
                                        v-if="
                                          post.parent_post.company &&
                                          post.parent_post.is_company == 1
                                        "
                                      >
                                        <img
                                          :src="post.parent_post.company.image_url"
                                          alt=""
                                          class="avatar-md h-auto d-block rounded-circle mr-3"
                                          v-if="post.parent_post.company.image"
                                          style="
                                            height: 35px !important;
                                            width: 35px !important;
                                          "
                                          @error="companyimageNotFound"
                                        />
                                        <img
                                          :src="company_image"
                                          alt=""
                                          class="avatar-md h-auto d-block rounded-circle mr-3"
                                          style="
                                            height: 35px !important;
                                            width: 35px !important;
                                          "
                                          v-else
                                        />

                                        <!-- <b-avatar
                                          variant="info"
                                          :src="post.parent_post.company.image_url"
                                          class="mr-3"
                                          v-if="post.parent_post.company.image"
                                        ></b-avatar>
                                        <b-avatar
                                          variant="info"
                                          :src="company_image"
                                          class="mr-3"
                                          v-else
                                        ></b-avatar> -->
                                        <div style="display: grid">
                                          <span class="font-size-15 mr-auto text-dark">{{
                                            post.parent_post.company.name
                                          }}</span>
                                          <small
                                            v-if="post.parent_post.created_at"
                                            class="text-muted"
                                            >{{
                                              moment(
                                                post.parent_post.created_at
                                              ).fromNow()
                                            }}
                                          </small>
                                          <small v-else class="text-muted">-</small>
                                        </div>
                                      </div>

                                      <div
                                        style="display: flex; align-items: center"
                                        v-if="
                                          post.parent_post.user &&
                                          post.parent_post.is_company == 0
                                        "
                                      >
                                        <img
                                          :src="post.parent_post.user.image_url"
                                          alt=""
                                          class="avatar-md h-auto d-block rounded-circle mr-3"
                                          v-if="post.parent_post.user.image"
                                          style="
                                            height: 35px !important;
                                            width: 35px !important;
                                          "
                                          @error="userimageNotFound"
                                        />
                                        <img
                                          :src="user_image"
                                          alt=""
                                          class="avatar-md h-auto d-block rounded-circle mr-3"
                                          style="
                                            height: 35px !important;
                                            width: 35px !important;
                                          "
                                          v-else
                                        />

                                        <!-- <b-avatar
                                          variant="info"
                                          :src="post.parent_post.user.image_url"
                                          class="mr-3"
                                          v-if="post.parent_post.user.image"
                                        ></b-avatar>
                                        <b-avatar
                                          variant="info"
                                          :src="user_image"
                                          class="mr-3"
                                          v-else
                                        ></b-avatar> -->
                                        <div style="display: grid">
                                          <span class="font-size-15 mr-auto text-dark">{{
                                            post.parent_post.user.name
                                          }}</span>

                                          <small
                                            v-if="post.parent_post.created_at"
                                            class="text-muted"
                                            >{{
                                              moment(
                                                post.parent_post.created_at
                                              ).fromNow()
                                            }}</small
                                          >
                                          <small v-else class="text-muted">-</small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="pl-1 pr-1">
                                    <div v-if="post && post.parent_post.post_description !== null && post.parent_post.post_description !== ''">
                                      <div
                                        v-html="post.parent_post.post_description"
                                        id="app"
                                        style="white-space: pre-wrap"
                                        class="text-dark"
                                        v-if="
                                          post.parent_post.post_description.length < 500
                                        "
                                      ></div>
  
                                      <div
                                        v-html="
                                          post.parent_post.post_description.substring(
                                            0,
                                            500
                                          ) + '..'
                                        "
                                        id="app"
                                        style="white-space: pre-wrap"
                                        class="text-dark pt-3"
                                        v-else
                                      ></div>
                                      <div
                                        v-if="
                                          post.parent_post.post_description.length > 500
                                        "
                                        class="mb-2"
                                      >
                                        <router-link
                                          :to="{
                                            name: 'company.newsfeeds.show',
                                            params: { id: post.id },
                                          }"
                                          class="text-primary"
                                          >Read more <i class="mdi mdi-arrow-right"></i
                                        ></router-link>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                                  <div class="pl-1 pr-1">
                                    <div  v-if="post.parent_post.website_url || post.parent_post.posts_images.length > 0 && post.parent_post.type !== 'Poll' " >
                                      <div
                                        class="position-relative mb-3 mt-3"
                                        v-if="post.parent_post.website_url"
                                      >
                                        <div class="repost-border1">
                                          <a
                                            :href="post.parent_post.website_url"
                                            class="text-primary"
                                            target="_blank"
                                          >
                                            <div class="" style="width: 100% !important">
                                              <div
                                                style="
                                                  display: flex;
                                                  align-items: center;
                                                  width: 100% !important;
                                                  justify-content: space-between;
                                                "
                                              >
                                                <div
                                                  style="
                                                    display: flex;
                                                    align-items: center;
                                                  "
                                                >
                                                  <img
                                                    :src="
                                                      post.parent_post.website_detail
                                                        .website_image
                                                    "
                                                    alt=""
                                                    v-if="
                                                      post.parent_post.website_detail
                                                        .website_image
                                                    "
                                                    style="
                                                      width: 100% !important;
                                                      object-fit: cover;
                                                    "
                                                    @error="companyimageNotFound"
                                                  />
                                                </div>
                                              </div>
                                              <div
                                                style="
                                                  background-color: #e8e8e8;
                                                  width: 100% !important;
                                                  object-fit: cover;
                                                  padding: 10px;
                                                "
                                              >
                                                <span
                                                  style="color: #000"
                                                  class="text-dark"
                                                  v-if="
                                                    post.parent_post.website_detail
                                                      .website_title
                                                  "
                                                >
                                                  <h6>
                                                    {{
                                                      post.parent_post.website_detail
                                                        .website_title
                                                    }}
                                                  </h6>
                                                </span>
                                                <span
                                                  style="color: #000"
                                                  class="text-dark"
                                                  v-if="
                                                    post.parent_post.website_detail
                                                      .website_description
                                                  "
                                                >
                                                  {{
                                                    post.parent_post.website_detail
                                                      .website_description
                                                  }}
                                                </span>
                                              </div>
                                            </div>
                                          </a>
                                        </div>
                                      </div>
                                      <div class="position-relative mb-3 mt-3" v-else>
                                        <div
                                          v-if="post.parent_post.posts_images.length > 1"
                                        >
                                          <slider
                                            animation="fade"
                                            height="400px"
                                            width="auto"
                                          >
                                            <slider-item
                                              v-for="(image, index) in post.parent_post
                                                .posts_images"
                                              :key="index"
                                            >
                                              <img
                                                :src="
                                                  image.image_path + '/' + image.image
                                                "
                                                width="665px;"
                                                style="height: 400px !important"
                                                @error="imageNotFound"
                                              />
                                            </slider-item>
                                          </slider>
                                        </div>
                                        <div
                                          v-else-if="
                                            post.parent_post.posts_images.length == 1
                                          "
                                        >
                                          <video
                                            style="
                                              height: auto !important;
                                              width: 100% !important;
                                              object-fit: cover;
                                            "
                                            v-if="
                                              post.parent_post.posts_images[0].type ==
                                              'Video'
                                            "
                                            controls
                                            :src="
                                              post.parent_post.posts_images[0]
                                                .image_path +
                                              '/' +
                                              post.parent_post.posts_images[0].image
                                            "
                                          ></video>

                                          <img
                                            :src="
                                              post.parent_post.posts_images[0]
                                                .image_path +
                                              '/' +
                                              post.parent_post.posts_images[0].image
                                            "
                                            alt=""
                                            v-if="
                                              post.parent_post.posts_images[0].type ==
                                              'Image'
                                            "
                                            class="img-thumbnail"
                                            width="100%;"
                                            @error="imageNotFound"
                                          />
                                          <!-- style="
                                              height: 100px !important;
                                              width: 100% !important;
                                            " -->
                                          <div
                                            class="embed-responsive embed-responsive-16by9"
                                            v-if="
                                              post.parent_post.posts_images[0].type ==
                                              'File'
                                            "
                                          >
                                            <iframe
                                              class="embed-responsive-item vue_frame"
                                              :src="
                                                post.parent_post.posts_images[0]
                                                  .image_path +
                                                '/' +
                                                post.parent_post.posts_images[0].image
                                              "
                                            ></iframe>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div v-else>
                                      <div v-if="post.parent_post.type == 'Poll'">
                                        <div class="position-relative pt-3 pb-2 pl-1">
                                          <div class="border p-1 box-sha ">
                                            <h6 class="p-1"> {{ post.parent_post.question }}</h6>
                                            <div>
                                              <template v-if="post.poll_result">
                                                <div v-if="!post.parent_post.votes_count">
                                                  <div v-for="(option, index) in post.parent_post.options" :key="index" class="p-1 text-center options" :class="{ 'mt-1': index >= 1 }" >
                                                    <div>{{ option }}</div>
                                                  </div>
                                                </div>
                                                <div v-else>
                                                  <div v-if="post.parent_post.votes_count">
                                                    <div  v-for="(vote,index) in post.parent_post.votes" :key="index">
                                                      <h6 class="mt-1 vote-count p-1">{{ index }}</h6>
                                                      <template v-if="((vote/post.parent_post.votes_count) * 100).toFixed(2) > 0">
                                                        <b-progress :max="100" height="1rem" animated>
                                                          <b-progress-bar :value="((vote/post.parent_post.votes_count) * 100).toFixed(2)" >
                                                            <strong>{{ ((vote/post.parent_post.votes_count) * 100).toFixed(2) }}%</strong>
                                                          </b-progress-bar>
                                                        </b-progress>
                                                      </template>
                                                      <template v-else>
                                                        <div class="justify-content-around progress" style="line-height:2!important;height: 1rem!important;">
                                                          <p class="text-center"><strong>0%</strong></p>
                                                        </div>
                                                      </template>
                                                    </div>
                                                  </div>
                                                </div>
                                              </template>
                                              <template v-else>
                                                <div v-if="!post.parent_post.is_voted">
                                                  <div v-for="(option, index) in post.parent_post.options" :key="index" class="p-1 text-center options" :class="{ 'mt-1': index >= 1 }" >
                                                    <div @click="postVote(post.parent_post.id,option)">{{ option }}</div>
                                                  </div>
                                                </div>
                                                <div v-if="post.parent_post.is_voted">
                                                  <div  v-for="(vote,index) in post.parent_post.votes" :key="index">
                                                    <h6 class="mt-1 vote-count p-1">{{ index }}</h6>
                                                    <template v-if="((vote/post.parent_post.votes_count) * 100).toFixed(2) > 0">
                                                      <b-progress :max="100" height="1rem" animated>
                                                        <b-progress-bar :value="((vote/post.parent_post.votes_count) * 100).toFixed(2)" >
                                                          <strong>{{ ((vote/post.parent_post.votes_count) * 100).toFixed(2) }}%</strong>
                                                        </b-progress-bar>
                                                      </b-progress>
                                                    </template>
                                                    <template v-else>
                                                      <div class="justify-content-around progress" style="line-height:2!important;height: 1rem!important;">
                                                        <p class="text-center"><strong>0%</strong></p>
                                                      </div>
                                                    </template>
                                                  </div>
                                                </div>
                                              </template>
                                              <h6 class="mt-2 vote-count p-1"> {{ post.parent_post.votes_count }} Votes</h6>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <ul
                                      class="list-inline"
                                      style="
                                        display: flex;
                                        justify-content: space-between;
                                      "
                                    >
                                      <li class="list-inline-item">
                                        <i
                                          class="bx bx-like align-middle text-muted me-1"
                                        ></i>
                                        {{
                                          post.parent_post.like_admin.length +
                                          post.parent_post.like_companies.length +
                                          post.parent_post.like_users.length
                                        }}
                                        Likes
                                      </li>
                                      <li class="list-inline-item">
                                        <i
                                          class="bx bx-comment-dots align-middle text-muted me-1"
                                        ></i>
                                        {{ post.parent_post.comments.length }} Comments
                                      </li>
                                    </ul>
                                  </div>
                              </div>
                            </div>
                          </div>
                          
                          <div class="pl-3 pr-3 pt-3">
                            <ul
                              class="list-inline"
                              style="display: flex; justify-content: space-between"
                            >
                              <li class="list-inline-item">
                                <a
                                  class="text-muted"
                                  href="javascript:void(0)"
                                  @click="getToggelData(post.id)"
                                >
                                  <i class="bx bx-like align-middle text-muted me-1"></i>
                                  {{
                                    post.like_users.length + post.like_companies.length
                                  }}
                                  Likes
                                </a>
                              </li>
                              <li class="list-inline-item">
                                <router-link
                                  :to="{
                                    name: 'post.show',
                                    params: { id: post.id },
                                  }"
                                  class="text-muted"
                                >
                                  <i
                                    class="bx bx-comment-dots align-middle text-muted me-1"
                                  ></i>
                                  {{ post.comment_count }} Comments
                                </router-link>

                                <!-- <a class="text-muted" :href="'/posts/show/' + post.id">
                                </a> -->
                              </li>
                            </ul>
                          </div>
                          <hr class="my-1" />
                          <div class="pl-3 pr-3 pt-2">
                            <ul
                              class="list-inline text-muted"
                              style="display: flex; justify-content: space-between"
                            >
                              <li
                                class="list-inline-item w-50 likes-post"
                                v-if="post.like_Company_Data.length > 0"
                                style="text-align: center"
                              >
                                <a
                                  @click="likes(post.id)"
                                  class="text-muted"
                                  href="javascript:void(0)"
                                >
                                  <i
                                    class="bx bxs-like align-middle text-muted me-1 bx-sm"
                                  ></i>
                                </a>
                              </li>
                              <li
                                class="list-inline-item w-50 likes-post"
                                v-else
                                style="text-align: center"
                              >
                                <a
                                  @click="likes(post.id)"
                                  class="text-muted"
                                  href="javascript:void(0)"
                                >
                                  <i
                                    class="bx bx-like align-middle text-muted me-1 bx-sm"
                                  ></i>
                                </a>
                              </li>

                              <li
                                class="list-inline-item w-50"
                                style="text-align: center"
                              >
                                <a
                                  @click="comments(post.id)"
                                  class="text-muted"
                                  href="javascript:void(0)"
                                >
                                  <i
                                    class="bx bx-comment-dots align-middle text-muted me-1 bx-sm"
                                  ></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-else>
                      <div class="col-sm-12" v-for="post in posts" :key="post.id">
                        <div
                          style="
                            display: flex;
                            align-items: center;
                            width: 100% !important;
                            justify-content: space-between;
                          "
                        >
                          <div style="display: flex; align-items: center">
                            <img
                              :src="
                                post.auth_details.image_path +
                                '/' +
                                post.auth_details.image
                              "
                              alt=""
                              class="avatar-md h-auto d-block rounded-circle mr-3"
                              v-if="post.auth_details.image"
                              style="height: 35px !important; width: 35px !important"
                              @error="companyimageNotFound"
                            />
                            <img
                              :src="company_image"
                              alt=""
                              class="avatar-md h-auto d-block rounded-circle mr-3"
                              style="height: 35px !important; width: 35px !important"
                              v-else
                            />

                            <!-- <b-avatar
                              variant="info"
                              :src="
                                post.auth_details.image_path +
                                '/' +
                                post.auth_details.image
                              "
                              class="mr-3"
                              v-if="post.auth_details.image"
                            ></b-avatar>
                            <b-avatar
                              variant="info"
                              :src="company_image"
                              class="mr-3"
                              v-else
                            ></b-avatar> -->
                            <div style="display: grid">
                              <router-link
                                :to="{
                                  name: 'post.show',
                                  params: { id: post.id },
                                }"
                                class="text-dark"
                                ><span class="font-size-15 mr-auto">{{
                                  post.auth_details.name
                                }}</span></router-link
                              >

                              <small v-if="post.created_at" class="text-muted">{{
                                moment(post.created_at).fromNow()
                              }}</small>
                              <small v-else class="text-muted">-</small>
                            </div>
                          </div>

                          <b-dropdown
                            class="float-right ml-5"
                            toggle-class="text-muted p-0"
                            right
                            variant="white"
                          >
                            <template v-slot:button-content>
                              <i class="mdi mdi-dots-horizontal font-size-18"></i>
                            </template>
                            <b-dropdown-item
                              @click="editPostName(post.id)"
                              v-if="!post.repost_id && !post.parent_post"
                              >Edit</b-dropdown-item
                            >
                            <b-dropdown-item @click="deletePostName(post.id)"
                              >Delete</b-dropdown-item
                            >
                            <!-- <b-dropdown-item @click="reportPostName(post.id)"
                              >Report</b-dropdown-item
                            > -->
                          </b-dropdown>
                        </div>
                        <input type="hidden" :value="post.id" />
                        <div v-if="!post.parent_post">
                          <div class="pe-3 pt-3">
                            <div v-if="post && post.post_description !== null && post.post_description !== ''">
                              <div
                                v-html="post.post_description"
                                id="app"
                                style="white-space: pre-wrap"
                                class="text-dark"
                                v-on:click="isHidden = false"
                                @click="showPostDetail(post.id)"
                                v-if="post.post_description.length < 500"
                              ></div>
  
                              <div
                                v-html="post.post_description.substring(0, 500) + '..'"
                                id="app"
                                style="white-space: pre-wrap"
                                class="text-dark"
                                v-on:click="isHidden = false"
                                @click="showPostDetail(post.id)"
                                v-else
                              ></div>
                              <div v-if="post.post_description.length > 500" class="mb-2">
                                <router-link
                                  :to="{
                                    name: 'post.show',
                                    params: { id: post.id },
                                  }"
                                  class="text-primary"
                                  >Read more <i class="mdi mdi-arrow-right"></i
                                ></router-link>
                              </div>
                            </div>
                          </div>

                          <div v-if="post.website_url || post.images.length > 0 && post.type !== 'Poll'">
                            <div
                              class="position-relative ml-2 mr-2 mb-2"
                              v-if="post.website_url"
                            >
                              <div class="repost-border1">
                                <a
                                  :href="post.website_url"
                                  class="text-primary"
                                  target="_blank"
                                >
                                  <div class="" style="width: 100% !important">
                                    <div
                                      style="
                                        display: flex;
                                        align-items: center;
                                        width: 100% !important;
                                        justify-content: space-between;
                                      "
                                    >
                                      <div style="display: flex; align-items: center">
                                        <img
                                          :src="post.website_image"
                                          alt=""
                                          v-if="post.website_image"
                                          style="
                                            width: 100% !important;
                                            object-fit: cover;
                                          "
                                          @error="companyimageNotFound"
                                        />
                                      </div>
                                    </div>
                                    <div
                                      style="
                                        background-color: #e8e8e8;
                                        width: 100% !important;
                                        object-fit: cover;
                                        padding: 10px;
                                      "
                                    >
                                      <span
                                        style="color: #000"
                                        class="text-dark"
                                        v-if="post.website_title"
                                      >
                                        <h6>{{ post.website_title }}</h6>
                                      </span>
                                      <span
                                        style="color: #000"
                                        class="text-dark"
                                        v-if="post.website_description"
                                      >
                                        {{ post.website_description }}
                                      </span>
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </div>

                            <div class="position-relative" v-else>
                              <div v-if="post.images.length > 1">
                                <slider animation="fade" style="width: 100% !important">
                                  <slider-item
                                    v-for="index in post.images"
                                    :key="index"
                                    @click="hello"
                                  >
                                    <img
                                      :src="index.image_path + '/' + index.image"
                                      style="
                                        height: 300px !important;
                                        width: 100% !important;
                                        object-fit: cover;
                                      "
                                      @error="imageNotFound"
                                    />
                                  </slider-item>
                                </slider>
                              </div>
                              <div v-else-if="post.images.length == 1">
                                <video
                                  style="
                                    height: auto !important;
                                    width: 100% !important;
                                    object-fit: cover;
                                  "
                                  v-if="post.images[0].type == 'Video'"
                                  controls
                                  :src="
                                    post.images[0].image_path + '/' + post.images[0].image
                                  "
                                ></video>
                                <img
                                  :src="
                                    post.images[0].image_path + '/' + post.images[0].image
                                  "
                                  alt=""
                                  class="img-thumbnail"
                                  v-if="post.images[0].type == 'Image'"
                                  style="
                                    height: auto !important;
                                    width: 100% !important;
                                    object-fit: cover;
                                  "
                                  @error="imageNotFound"
                                />
                                <!-- <vue-iframe
                                    v-if="post.images[0].type == 'File'"
                                    :src="
                                      post.images[0].image_path + '/' + post.images[0].image
                                    "
                                    allow="camera *; geolocation *; microphone *; autoplay *"
                                    frame-id="my-ifram"
                                    @load="onLoad"
                                    name="my-frame"
                                    :scrolling="iframeScrolling"
                                    :width="iframeWidth"
                                    :height="iframeHeight"
                                    class="vue_frame"
                                  /> -->
                                <div
                                  class="embed-responsive embed-responsive-16by9"
                                  v-if="post.images[0].type == 'File'"
                                >
                                  <iframe
                                    class="embed-responsive-item vue_frame"
                                    :src="
                                      post.images[0].image_path +
                                      '/' +
                                      post.images[0].image
                                    "
                                  ></iframe>
                                </div>
                                <!-- <span v-if="post.images[0].type == 'File'" class="pl-3">{{
                                    post.images[0].image
                                  }}</span> -->
                              </div>
                              <div v-else>
                                <img
                                  :src="image_url"
                                  alt=""
                                  class="img-thumbnail"
                                  style="
                                    height: auto !important;
                                    width: 100% !important;
                                    object-fit: cover;
                                  "
                                />
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="post.type == 'Poll'">
                              <div class="position-relative pt-3 pb-2 pl-3">
                                <div class="border p-1 box-sha ">
                                  <h6 class="p-1"> {{ post.question }}</h6>
                                  <div>
                                    <template v-if="post.poll_result">
                                      <div v-if="!post.votes_count">
                                        <div v-for="(option, index) in post.options" :key="index" class="p-1 text-center options" :class="{ 'mt-1': index >= 1 }" >
                                          <div>{{ option }}</div>
                                        </div>
                                      </div>
                                      <div v-else>
                                        <div v-if="post.votes_count">
                                          <div  v-for="(vote,index) in post.votes" :key="index">
                                            <h6 class="mt-1 vote-count p-1">{{ index }}</h6>
                                            <template v-if="((vote/post.votes_count) * 100).toFixed(2) > 0">
                                              <b-progress :max="100" height="1rem" animated>
                                                <b-progress-bar :value="((vote/post.votes_count) * 100).toFixed(2)" >
                                                  <strong>{{ ((vote/post.votes_count) * 100).toFixed(2) }}%</strong>
                                                </b-progress-bar>
                                              </b-progress>
                                            </template>
                                            <template v-else>
                                              <div class="justify-content-around progress" style="line-height:2!important;height: 1rem!important;">
                                                <p class="text-center"><strong>0%</strong></p>
                                              </div>
                                            </template>
                                          </div>
                                        </div>
                                      </div>
                                    </template> 
                                    <template v-else>
                                      <div v-if="!post.is_voted">
                                        <div v-for="(option, index) in post.options" :key="index" class="p-1 text-center options" :class="{ 'mt-1': index >= 1 }" >
                                          <div @click="postVote(post.id,option)">{{ option }}</div>
                                        </div>
                                      </div>
                                      <div v-if="post.is_voted">
                                        <div  v-for="(vote,index) in post.votes" :key="index">
                                          <h6 class="mt-1 vote-count p-1">{{ index }}</h6>
                                          <template v-if="((vote/post.votes_count) * 100).toFixed(2) > 0">
                                            <b-progress :max="100" height="1rem" animated>
                                              <b-progress-bar :value="((vote/post.votes_count) * 100).toFixed(2)" >
                                                <strong>{{ ((vote/post.votes_count) * 100).toFixed(2) }}%</strong>
                                              </b-progress-bar>
                                            </b-progress>
                                          </template>
                                          <template v-else>
                                            <div class="justify-content-around progress" style="line-height:2!important;height: 1rem!important;">
                                              <p class="text-center"><strong>0%</strong></p>
                                            </div>
                                          </template>
                                        </div>
                                      </div>
                                    </template>
                                    <h6 class="mt-2 vote-count p-1"> {{ post.votes_count }} Votes</h6>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="pb-3 pt-3 pr-2 pl-2" v-else>
                          <div v-if="post.repost_id && post.parent_post">
                            <div v-if="post && post.post_description !== null && post.post_description !== ''">
                              <div
                                v-html="post.post_description"
                                id="app"
                                style="white-space: pre-wrap"
                                class="text-dark pb-3"
                                v-if="post.post_description.length < 500"  
                              ></div>
                              <div
                                v-html="
                                  post.post_description.substring(
                                    0,
                                    500
                                  ) + '..'
                                "
                                id="app"
                                style="white-space: pre-wrap"
                                class="text-dark pb-3"
                                v-else
                              ></div>
                              <div
                                v-if="post.post_description.length > 500"
                                class="mb-2"
                              >
                                <router-link
                                  :to="{
                                    name: 'company.newsfeeds.show',
                                    params: { id: post.id },
                                  }"
                                  class="text-primary"
                                  >Read more <i class="mdi mdi-arrow-right"></i
                                ></router-link>
                              </div>
                            </div>
                            <div class="repost-border pr-2 pl-2">
                              <a
                                class="text-dark"
                                href="javascript:void(0)"
                                @click="getRepostData(post.repost_id)"
                              >
                                <div class="p-3">
                                  <div
                                    style="
                                      display: flex;
                                      align-items: center;
                                      width: 100% !important;
                                      justify-content: space-between;
                                    "
                                  >
                                    <div
                                      style="display: flex; align-items: center"
                                      v-if="
                                        post.parent_post.company &&
                                        post.parent_post.is_company == 1
                                      "
                                    >
                                      <img
                                        :src="post.parent_post.company.image_url"
                                        alt=""
                                        class="avatar-md h-auto d-block rounded-circle mr-3"
                                        v-if="post.parent_post.company.image"
                                        style="
                                          height: 35px !important;
                                          width: 35px !important;
                                        "
                                        @error="companyimageNotFound"
                                      />
                                      <img
                                        :src="company_image"
                                        alt=""
                                        class="avatar-md h-auto d-block rounded-circle mr-3"
                                        style="
                                          height: 35px !important;
                                          width: 35px !important;
                                        "
                                        v-else
                                      />

                                      <!-- <b-avatar
                                        variant="info"
                                        :src="post.parent_post.company.image_url"
                                        class="mr-3"
                                        v-if="post.parent_post.company.image"
                                      ></b-avatar>
                                      <b-avatar
                                        variant="info"
                                        :src="company_image"
                                        class="mr-3"
                                        v-else
                                      ></b-avatar> -->
                                      <div style="display: grid">
                                        <span class="font-size-15 mr-auto text-dark">{{
                                          post.parent_post.company.name
                                        }}</span>
                                        <small
                                          v-if="post.parent_post.created_at"
                                          class="text-muted"
                                          >{{
                                            moment(post.parent_post.created_at).fromNow()
                                          }}
                                        </small>
                                        <small v-else class="text-muted">-</small>
                                      </div>
                                    </div>

                                    <div
                                      style="display: flex; align-items: center"
                                      v-if="
                                        post.parent_post.user &&
                                        post.parent_post.is_company == 0
                                      "
                                    >
                                      <img
                                        :src="post.parent_post.user.image_url"
                                        alt=""
                                        class="avatar-md h-auto d-block rounded-circle mr-3"
                                        v-if="post.parent_post.user.image"
                                        style="
                                          height: 35px !important;
                                          width: 35px !important;
                                        "
                                        @error="userimageNotFound"
                                      />
                                      <img
                                        :src="user_image"
                                        alt=""
                                        class="avatar-md h-auto d-block rounded-circle mr-3"
                                        style="
                                          height: 35px !important;
                                          width: 35px !important;
                                        "
                                        v-else
                                      />
                                      <!-- <b-avatar
                                        variant="info"
                                        :src="post.parent_post.user.image_url"
                                        class="mr-3"
                                        v-if="post.parent_post.user.image"
                                      ></b-avatar>
                                      <b-avatar
                                        variant="info"
                                        :src="user_image"
                                        class="mr-3"
                                        v-else
                                      ></b-avatar> -->
                                      <div style="display: grid">
                                        <span class="font-size-15 mr-auto text-dark">{{
                                          post.parent_post.user.name
                                        }}</span>

                                        <small
                                          v-if="post.parent_post.created_at"
                                          class="text-muted"
                                          >{{
                                            moment(post.parent_post.created_at).fromNow()
                                          }}</small
                                        >
                                        <small v-else class="text-muted">-</small>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="pl-3 pr-3">
                                  <div v-if="post && post.post_description !== null && post.post_description !== ''">
                                    <div
                                      v-html="post.parent_post.post_description"
                                      id="app"
                                      style="white-space: pre-wrap"
                                      class="text-dark"
                                      v-if="post.parent_post.post_description.length < 500"
                                    ></div>
  
                                    <div
                                      v-html="
                                        post.parent_post.post_description.substring(
                                          0,
                                          500
                                        ) + '..'
                                      "
                                      id="app"
                                      style="white-space: pre-wrap"
                                      class="text-dark pt-3"
                                      v-else
                                    ></div>
                                    <div
                                      v-if="post.parent_post.post_description.length > 500"
                                      class="mb-2"
                                    >
                                      <router-link
                                        :to="{
                                          name: 'company.newsfeeds.show',
                                          params: { id: post.id },
                                        }"
                                        class="text-primary"
                                        >Read more <i class="mdi mdi-arrow-right"></i
                                      ></router-link>
                                    </div>
                                  </div>
                                </div>
                              </a>
                                <div class="pl-3 pr-3">
                                  <div v-if="post.parent_post.website_url || post.parent_post.posts_images.length > 0 && post.parent_post.type !== 'Poll'" >
                                    <div
                                      class="position-relative mb-3 mt-3"
                                      v-if="post.parent_post.website_url"
                                    >
                                      <div class="repost-border1">
                                        <a
                                          :href="post.parent_post.website_url"
                                          class="text-primary"
                                          target="_blank"
                                        >
                                          <div class="" style="width: 100% !important">
                                            <div
                                              style="
                                                display: flex;
                                                align-items: center;
                                                width: 100% !important;
                                                justify-content: space-between;
                                              "
                                            >
                                              <div
                                                style="display: flex; align-items: center"
                                              >
                                                <img
                                                  :src="
                                                    post.parent_post.website_detail
                                                      .website_image
                                                  "
                                                  alt=""
                                                  v-if="
                                                    post.parent_post.website_detail
                                                      .website_image
                                                  "
                                                  style="
                                                    width: 100% !important;
                                                    object-fit: cover;
                                                  "
                                                  @error="companyimageNotFound"
                                                />
                                              </div>
                                            </div>
                                            <div
                                              style="
                                                background-color: #e8e8e8;
                                                width: 100% !important;
                                                object-fit: cover;
                                                padding: 10px;
                                              "
                                            >
                                              <span
                                                style="color: #000"
                                                class="text-dark"
                                                v-if="
                                                  post.parent_post.website_detail
                                                    .website_title
                                                "
                                              >
                                                <h6>
                                                  {{
                                                    post.parent_post.website_detail
                                                      .website_title
                                                  }}
                                                </h6>
                                              </span>
                                              <span
                                                style="color: #000"
                                                class="text-dark"
                                                v-if="
                                                  post.parent_post.website_detail
                                                    .website_description
                                                "
                                              >
                                                {{
                                                  post.parent_post.website_detail
                                                    .website_description
                                                }}
                                              </span>
                                            </div>
                                          </div>
                                        </a>
                                      </div>
                                    </div>
                                    <div class="position-relative mb-3 mt-3" v-else>
                                      <div
                                        v-if="post.parent_post.posts_images.length > 1"
                                      >
                                        <slider
                                          animation="fade"
                                          height="400px"
                                          width="auto"
                                        >
                                          <slider-item
                                            v-for="(image, index) in post.parent_post
                                              .posts_images"
                                            :key="index"
                                          >
                                            <img
                                              :src="image.image_path + '/' + image.image"
                                              width="665px;"
                                              style="height: 400px !important"
                                              @error="imageNotFound"
                                            />
                                          </slider-item>
                                        </slider>
                                      </div>
                                      <div
                                        v-else-if="
                                          post.parent_post.posts_images.length == 1
                                        "
                                      >
                                        <video
                                          style="
                                            height: auto !important;
                                            width: 100% !important;
                                            object-fit: cover;
                                          "
                                          v-if="
                                            post.parent_post.posts_images[0].type ==
                                            'Video'
                                          "
                                          controls
                                          :src="
                                            post.parent_post.posts_images[0].image_path +
                                            '/' +
                                            post.parent_post.posts_images[0].image
                                          "
                                        ></video>

                                        <img
                                          :src="
                                            post.parent_post.posts_images[0].image_path +
                                            '/' +
                                            post.parent_post.posts_images[0].image
                                          "
                                          alt=""
                                          v-if="
                                            post.parent_post.posts_images[0].type ==
                                            'Image'
                                          "
                                          class="img-thumbnail"
                                          width="100%"
                                          @error="imageNotFound"
                                        />
                                        <!-- style="
                                            height: 250px !important;
                                            width: 100% !important;
                                          " -->
                                        <div
                                          class="embed-responsive embed-responsive-16by9"
                                          v-if="
                                            post.parent_post.posts_images[0].type ==
                                            'File'
                                          "
                                        >
                                          <iframe
                                            class="embed-responsive-item vue_frame"
                                            :src="
                                              post.parent_post.posts_images[0]
                                                .image_path +
                                              '/' +
                                              post.parent_post.posts_images[0].image
                                            "
                                          ></iframe>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-else>
                                    <div v-if="post.parent_post.type == 'Poll'">
                                      <div class="position-relative pt-3 pb-2 pl-3">
                                        <div class="border p-1 box-sha ">
                                          <h6 class="p-1"> {{ post.parent_post.question }}</h6>
                                          <div>
                                            <template v-if="post.poll_result">
                                              <div v-if="!post.parent_post.votes_count">
                                                <div v-for="(option, index) in post.parent_post.options" :key="index" class="p-1 text-center options" :class="{ 'mt-1': index >= 1 }" >
                                                  <div>{{ option }}</div>
                                                </div>
                                              </div>
                                              <div v-else>
                                                <div v-if="post.parent_post.votes_count">
                                                  <div  v-for="(vote,index) in post.parent_post.votes" :key="index">
                                                    <h6 class="mt-1 vote-count p-1">{{ index }}</h6>
                                                    <template v-if="((vote/post.parent_post.votes_count) * 100).toFixed(2) > 0">
                                                      <b-progress :max="100" height="1rem" animated>
                                                        <b-progress-bar :value="((vote/post.parent_post.votes_count) * 100).toFixed(2)" >
                                                          <strong>{{ ((vote/post.parent_post.votes_count) * 100).toFixed(2) }}%</strong>
                                                        </b-progress-bar>
                                                      </b-progress>
                                                    </template>
                                                    <template v-else>
                                                      <div class="justify-content-around progress" style="line-height:2!important;height: 1rem!important;">
                                                        <p class="text-center"><strong>0%</strong></p>
                                                      </div>
                                                    </template>
                                                  </div>
                                                </div>
                                              </div>
                                            </template>
                                            <template v-else>
                                              <div v-if="!post.parent_post.is_voted">
                                                <div v-for="(option, index) in post.parent_post.options" :key="index" class="p-1 text-center options" :class="{ 'mt-1': index >= 1 }" >
                                                  <div @click="postVote(post.parent_post.id,option)">{{ option }}</div>
                                                </div>
                                              </div>
                                              <div v-if="post.parent_post.is_voted">
                                                <div  v-for="(vote,index) in post.parent_post.votes" :key="index">
                                                  <h6 class="mt-1 vote-count p-1">{{ index }}</h6>
                                                  <template v-if="((vote/post.parent_post.votes_count) * 100).toFixed(2) > 0">
                                                    <b-progress :max="100" height="1rem" animated>
                                                      <b-progress-bar :value="((vote/post.parent_post.votes_count) * 100).toFixed(2)" >
                                                        <strong>{{ ((vote/post.parent_post.votes_count) * 100).toFixed(2) }}%</strong>
                                                      </b-progress-bar>
                                                    </b-progress>
                                                  </template>
                                                  <template v-else>
                                                    <div class="justify-content-around progress" style="line-height:2!important;height: 1rem!important;">
                                                      <p class="text-center"><strong>0%</strong></p>
                                                    </div>
                                                  </template>
                                                </div>
                                              </div>
                                            </template>
                                            <h6 class="mt-2 vote-count p-1"> {{ post.parent_post.votes_count }} Votes</h6>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                  <ul
                                    class="list-inline"
                                    style="display: flex; justify-content: space-between"
                                  >
                                    <li class="list-inline-item">
                                      <i
                                        class="bx bx-like align-middle text-muted me-1"
                                      ></i>
                                      {{
                                        post.parent_post.like_admin.length +
                                        post.parent_post.like_companies.length +
                                        post.parent_post.like_users.length
                                      }}
                                      Likes
                                    </li>
                                    <li class="list-inline-item">
                                      <i
                                        class="bx bx-comment-dots align-middle text-muted me-1"
                                      ></i>
                                      {{ post.parent_post.comments_count }} Comments
                                    </li>
                                  </ul>
                                </div>
                            </div>
                          </div>
                        </div>
                        <ul
                          class="list-inline pt-2"
                          style="display: flex; justify-content: space-between"
                        >
                          <li class="list-inline-item">
                            <a
                              class="text-muted"
                              href="javascript:void(0)"
                              @click="getToggelData(post.id)"
                              ><i class="bx bx-like align-middle text-muted me-1"></i>
                              {{ post.like_users.length + post.like_companies.length }}
                              Likes</a
                            >
                          </li>
                          <li class="list-inline-item">
                            <router-link
                              :to="{
                                name: 'post.show',
                                params: { id: post.id },
                              }"
                              class="text-muted"
                            >
                              <i
                                class="bx bx-comment-dots align-middle text-muted me-1"
                              ></i>
                              {{ post.comment_count }} Comments
                            </router-link>

                            <!-- <a class="text-muted" href="/blog-list"
                              ><i
                                class="bx bx-comment-dots align-middle text-muted me-1"
                              ></i>
                              {{ post.comment_count }} Comments</a
                            > -->
                          </li>
                        </ul>
                        <hr class="my-1" />
                        <ul
                          class="list-inline text-muted pt-2"
                          style="display: flex; justify-content: space-between"
                        >
                          <li
                            class="list-inline-item w-50 likes-post"
                            v-if="post.like_Company_Data.length > 0"
                            style="text-align: center"
                          >
                            <a
                              @click="likes(post.id)"
                              class="text-muted"
                              href="javascript:void(0)"
                            >
                              <i
                                class="bx bxs-like align-middle text-muted me-1 bx-sm"
                              ></i>
                            </a>
                          </li>
                          <li
                            class="list-inline-item w-50 likes-post"
                            v-else
                            style="text-align: center"
                          >
                            <a
                              @click="likes(post.id)"
                              class="text-muted"
                              href="javascript:void(0)"
                            >
                              <i
                                class="bx bx-like align-middle text-muted me-1 bx-sm"
                                @click="likes(post.id)"
                              ></i>
                            </a>
                          </li>

                          <li class="list-inline-item w-50" style="text-align: center">
                            <a
                              @click="comments(post.id)"
                              class="text-muted"
                              href="javascript:void(0)"
                            >
                              <i
                                class="bx bx-comment-dots align-middle text-muted me-1 bx-sm"
                              ></i>
                            </a>
                          </li>
                        </ul>
                        <hr class="" />
                      </div>
                      <br />
                    </div>
                  </div>
                  <div v-else class="justify-content-center row">
                    <label class="align-middle mt-2">No posts yet</label>
                  </div>
                  <b-sidebar
                    id="sidebar-rigth"
                    title="Likes"
                    right
                    :visible="showSidebar"
                    ref="mySidebar"
                    backdrop
                    shadow
                    @hidden="showSidebar = false"
                  >
                    <div class="px-3 py-2">
                      <b-tabs pills fill content-class="my-4">
                        <b-card-text>
                          <div>
                            <!-- <h5 class="font-size-14 mb-3">Users</h5> -->
                            <div style="max-height: 410px">
                              <ul class="list-unstyled chat-list">
                                <li class v-for="data of like_users" :key="data.id">
                                  <!-- :class="{ active: username == data.name }" -->
                                  <a href="javascript: void(0);">
                                    <div class="media">
                                      <div class="mr-3" v-if="data.role_id == '2'">
                                        <img
                                          :src="data.image_path + '/' + data.image"
                                          class="rounded-circle avatar-xs"
                                          style="height:40px; !important; width:40px !important"
                                          alt
                                          v-if="data.image"
                                          @error="companyimageNotFound"
                                        />
                                        <img
                                          :src="company_image"
                                          class="rounded-circle avatar-xs"
                                          style="height:40px; !important; width:40px !important"
                                          alt
                                          v-else
                                        />
                                      </div>
                                      <div class="mr-3" v-else>
                                        <img
                                          :src="data.image_path + '/' + data.image"
                                          class="rounded-circle avatar-xs"
                                          style="height:40px; !important; width:40px !important"
                                          alt
                                          v-if="data.image"
                                          @error="userimageNotFound"
                                        />
                                        <img
                                          :src="user_image"
                                          class="rounded-circle avatar-xs"
                                          style="height:40px; !important; width:40px !important"
                                          alt
                                          v-else
                                        />
                                      </div>
                                      <div class="media-body overflow-hidden">
                                        <h5
                                          class="text-truncate font-size-14"
                                          style="margin-bottom: 0.1px !important"
                                        >
                                          {{ data.name }}
                                        </h5>
                                        <span
                                          class="badge badge-secondary"
                                          v-if="data.role_id == '2'"
                                          >company</span
                                        >
                                        <span class="badge badge-secondary" v-else
                                          >user</span
                                        >
                                        <p class="text-truncate mb-0">{{ data.email }}</p>
                                      </div>
                                      <div class="font-size-11 text-muted">
                                        {{ moment(data.created_at).fromNow() }}
                                      </div>
                                    </div>
                                  </a>
                                  <hr class="mt-1 mb-1" />
                                </li>
                              </ul>
                            </div>
                          </div>
                        </b-card-text>
                      </b-tabs>
                    </div>
                  </b-sidebar>

                  <div class="text-center">
                    <ul class="pagination justify-content-center pagination-rounded">
                      <pagination
                        :data="paginations"
                        :limit="limit"
                        @pagination-change-page="getPosts"
                      ></pagination>
                    </ul>
                  </div>

                  <b-modal ref="my-modal" hide-footer title="Using Component Methods">
                    <template #modal-title> Report </template>
                    <input type="hidden" v-model="user.post_id" name="post_id" />
                    <form ref="form" @submit.prevent="reportSubmit">
                      <div class="d-block">
                        <textarea
                          class="text-muted"
                          v-model="user.message"
                          name="message"
                          style="width: 100% !important; height: 100px !important"
                          Placeholder="Type your message"
                          :class="{ 'is-invalid': $v.user.message.$error }"
                        ></textarea>
                        <div v-if="$v.user.message.$error" class="invalid-feedback">
                          <span v-if="!$v.user.message.required">
                            Please enter message</span
                          >
                          <span v-if="!$v.user.message.minLength">
                            Description should not less than 3</span
                          >
                          <span v-if="!$v.user.message.maxLength">
                            Description should not more than 5000</span
                          >
                        </div>
                      </div>
                      <br />
                      <div class="d-block">
                        <input
                          class="text-muted"
                          type="text"
                          name="email"
                          Placeholder="Email"
                          readonly
                          v-model="user.email"
                          style="width: 100% !important"
                        />
                      </div>

                      <b-button type="submit" class="mt-3" block>Submit</b-button>
                    </form>
                  </b-modal>
                </div>
              </div>
            </div>

            <!-- <div class="row">
              <div class="col-12 table-main-list customer-table table-responsive">
                <b-table  
                  :items="posts"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :busy="loading"
                  show-empty
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t('loading') }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(id)="data">
                    <span class="font-size-14 align-self-center">{{ data.item.id }}</span>
                  </template>
                  <template v-slot:cell(post_description)="data">
                    <h5 class="font-size-14">{{ data.item.post_description }}</h5>
                  </template>
                  <template v-slot:cell(is_active)="data">
                    <div
                      v-if="data.item.is_active == '1'"
                      class="badge badge-pill badge-soft-success font-size-12 mt-2"
                    >
                      Active
                    </div>
                    <div
                      v-else
                      class="badge badge-pill badge-soft-danger font-size-12 mt-2"
                    >
                      InActive
                    </div>
                  </template>
                  <template v-slot:cell(action)="data">
                    <div class="page-title-right d-flex">
                      <router-link :to="{ name: 'post.edit' , params: { id: data.item.id }, }" class="btn btn-success btn-rounded mr-2 add-btn">
                        Edit
                      </router-link>
                      <router-link :to="{ name: 'post.show' , params: { id: data.item.id }, }" class="btn btn-primary btn-rounded mr-2 add-btn">
                        Show
                      </router-link>
                      <button @click="deletePostName(data.item.id)" class="btn btn-danger btn-rounded export-btn">Delete</button>    
                    </div>
                  </template>
                  <template #empty>
                    <p class="text-center">{{ $t("companyManagement.no_post") }}</p>
                  </template>
                </b-table>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination :data="paginations" :limit="limit"
                        @pagination-change-page="getPosts "></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>  -->
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-xl-3">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="date-range-list">
                  <label>Search :</label>
                  <div class="text-sm">
                    <div class="search-box mr-2 d-inline-block w-100">
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control rounded-sm mb-3"
                          id="search"
                          @input="searchData()"
                          v-model="search"
                          :placeholder="$t('navbar.search.text')"
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>Per Page :</label>
                    <select
                      class="custom-select"
                      v-model="perPage"
                      @change="searchData()"
                    >
                      <option value="2" selected>2</option>
                      <option value="10">10</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>Status :</label>
                    <select class="custom-select" v-model="status" @change="searchData()">
                      <option value="">Both</option>
                      <option value="1" selected>Active</option>
                      <option value="0">InActive</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.likes-post:not(:last-child) {
  border-right: 2px solid #e3e4ea !important;
}
.vue_frame {
  height: 250px !important;
}
.repost-border {
  border: 1px solid;
  border-color: #d0d0d0;
}
.options{
  border: 1px solid deepskyblue;
  border-radius: 15px;
  font-size: 15px;
  color: #0face1;
  cursor: pointer;
}
.vote-count{
  color: #0face1;
}
</style>
